export const SET_DATA = "SET_DATA";
export const SET_CATEGORY_DATA = "SET_CATEGORY_DATA";
export const ADD_TO_CARD = "ADD_TO_CARD";
export const FILTER_CATEGORIES = "FILTER_CATEGORIES";
export const GET_SHOPPING_ITEMS = "GET_SHOPPING_ITEMS";
export const PAGINATE_BOOKS = "PAGINATE_BOOKS";
export const INCREASE_ITEM_COUNT = "INCREASE_ITEM_COUNT";
export const DECREASE_ITEM_COUNT = "DECREASE_ITEM_COUNT";
export const UPDATE_PAGINATE_BOOKS = "UPDATE_PAGINATE_BOOKS";
export const DELETE_BOOK = "DELETE_BOOK";
export const SET_USERS = "SET_USERS";
export const LOGGED_USER = "LOGGED_USER";
export const ADD_TO_FAVOURITE = "ADD_TO_FAVOURITE";
export const REMOVE_FAVOURITE = "REMOVE_FAVOURITE";
export const GET_FAVOURITES = "GET_FAVOURITES";